export default __webpack_public_path__ + "static/media/ic-drop-down.7b7277fa.svg";